import React, { useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MdErrorOutline } from "react-icons/md";
import { format } from 'date-fns';
import '../styles/App.css';
import { compatApi } from '../utils/Intercepter';
import useTokenStore from '../stores/tokens';


export default function UpdateUser() {
    const currentUser = useLocation().state;
    
    const initData = {
        organizationCode: currentUser.organizationCode!=null?currentUser.organizationCode:"",
        organizationName: currentUser.organizationName!=null?currentUser.organizationName:"",
        userName: currentUser.userName!=null?currentUser.userName:"",
        userEmail: currentUser.userEmail!=null?currentUser.userEmail:"",
        eipCertificated: currentUser.eipCertificated!=null?currentUser.eipCertificated:"",
        userRole: currentUser.userRole!=null?currentUser.userRole:"",
        joinDate:currentUser.joinDate!=null?format(currentUser.joinDate, 'yyyy-MM-dd'):"",
        leaveDate:currentUser.leaveDate!=null?format(currentUser.leaveDate, 'yyyy-MM-dd'):"",
        negotiationDate:currentUser.negotiationDate!=null?format(currentUser.negotiationDate, 'yyyy-MM-dd'):"",
        password:"",
    };

    const { user } = useTokenStore(); // TokenStore에서 현재 사용자 정보 가져오기
    const userRole = user?.currentRole || '';
    
    const navigate = useNavigate();
    
    const [userInput, setUserInput] = useState(initData);

    const userEmail = useRef(null);
    const password = useRef(null);
    const joinDate = useRef(null);
    const leaveDate = useRef(null);
    const negotiationDate = useRef(null);

    const [dateErr, setDateErr] = useState("");

    const changeUserEmailAndPassword = () => {
        userEmail.current.disabled = false;
        password.current.disabled = false;
    }

    const changePassword = () =>{
        password.current.disabled=false;
    }

    const resetJoinDate = () =>{
        joinDate.current.value="";
        userInput.joinDate = "";
    }

    const resetLeaveDate = () =>{
        leaveDate.current.value="";
        userInput.leaveDate ="";
    }

    const resetNegotiationDate = () =>{
        negotiationDate.current.value="";
        userInput.negotiationDate ="";
    }
    

    function handleInputChange(event) {
        const { name, value, type, checked } = event.target;

        setUserInput((prevState) => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value,
        }));
    }

    const handleSubmit = async(event) => {
        event.preventDefault();

        const joinDate = userInput.joinDate;
        const leaveDate = userInput.leaveDate;
        //const negotiationDate = userInput.negotiationDate;

        if(joinDate === ""){
            if(leaveDate){
                setDateErr("입사일을 입력해 주세요.")
                return;
            }
        }
        
        if(leaveDate !==""){
            if(joinDate>= leaveDate){
                setDateErr("퇴사일이 입사일보다 빠르거나 같습니다.")
                return;
            }
        }
        console.log("userInput = ", userInput);
        try {
            const response = await compatApi.post('/user/updateUser', userInput, {
                Authorization: `Bearer ${user.jwt}`,
            });

            const message = await response.text();
            alert(message);

            if(user.userRole ==='ADMIN'){
                navigate("/admin/readUserList");
            }else if(user.userRole ==='MASTER' || user.userRole ==='MANAGER'){
                navigate("/readEmployeeList");
            }else{

            }
            
        }
        catch (error) {
            alert(error);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            {/* <ReadOrganizationList userInput={userInput} onChange={handleInputChange} disabled={true} /> */}
            <div className="mb-3">
                <label htmlFor="organizationName" className="form-label">소속</label>
                <input id="organizationName" name="organizationName" type="text" value={userInput.organizationName} className="form-control" disabled={true} />
                {/* <select id="organizationCode" name="organizationCode" value={userInput.organizationCode} className="form-control" onChange={handleInputChange} disabled>
                    {optionList.map((option) => (
                        <option className="form-control" key={option.organizationCode} value={option.organizationCode}>
                            {option.organizationName}
                        </option>
                    ))}
                </select> */}
            </div>
            <div className="mb-3">
                <label htmlFor="userEmail" className="form-label">이메일</label>
                <input id="userEmail" name="userEmail" type="text" value={userInput.userEmail} className="form-control" disabled={true} ref={userEmail} />
            </div>
            <div className="d-flex align-items-center mb-2">
                <label htmlFor="password" className="form-label">비밀번호</label>
                <button type='button' className="btn btn-primary ms-auto" onClick={ userInput.userRole === 'ADMIN' ? changeUserEmailAndPassword : changePassword }>수정하기</button>
            </div>
            <input id="password" name="password" type="password" className="form-control" onChange={(event) => handleInputChange(event)} disabled={true} ref={password}/>
            <div className="d-flex align-items-center mb-2">
                <label htmlFor="joinDate" className="form-label">입사일</label>
                <button type='button' className="btn btn-primary ms-auto" onClick={resetJoinDate}>비우기</button>
            </div>
            <input id="joinDate" name="joinDate" type="date" value={userInput.joinDate} className="form-control" onChange={(event) => handleInputChange(event)} ref={joinDate}/>


            {dateErr && <div className="text-danger mt-2"><MdErrorOutline size={20} className="me-2" />{dateErr}</div>}


            <div className="d-flex align-items-center mb-2">
                <label htmlFor="leaveDate" className="form-label">퇴사일</label>
                <button type='button' className="btn btn-primary ms-auto" onClick={resetLeaveDate}>비우기</button>
            </div>
            <input id="leaveDate" name="leaveDate" type="date" value={userInput.leaveDate} className="form-control" onChange={(event) => handleInputChange(event)} ref={leaveDate}/>


            <div className="d-flex align-items-center mb-2">
                <label htmlFor="negotiationDate" className="form-label">연봉협상일</label>
                <button type='button' className="btn btn-primary ms-auto" onClick={resetNegotiationDate}>비우기</button>
            </div>
            <input id="negotiationDate" name="negotiationDate" type="date" value={userInput.negotiationDate} className="form-control" onChange={(event) => handleInputChange(event)} ref={negotiationDate}/>


            <div className="form-check">
                <input id="eipCertificated" name="eipCertificated" type="checkbox" checked={userInput.eipCertificated} className="form-check-input" onChange={(event) => handleInputChange(event)} />
                <label htmlFor="eipCertificated" className="form-check-label">정보처리기사 보유</label>
            </div>
            <div className="mb-3">
                <label htmlFor="userRole" className="form-label">권한</label>
                {userRole === 'ADMIN' && (
                    <select id="userRole" name="userRole" value={userInput.userRole} className="form-control" onChange={(event) => handleInputChange(event)}>
                        <option className="form-control" key="MASTER" value="MASTER">MASTER</option>
                        <option className="form-control" key="MANAGER" value="MANAGER">MANAGER</option>
                        <option className="form-control" key="STAFF" value="STAFF">STAFF</option>
                    </select>
                )}
                {(userRole === 'MASTER') && (
                    <select id="userRole" name="userRole" value={userInput.userRole} className="form-control" onChange={(event) => handleInputChange(event)}>
                        <option className="form-control" key="MASTER" value="MASTER">MASTER</option>
                        <option className="form-control" key="MANAGER" value="MANAGER">MANAGER</option>
                        <option className="form-control" key="STAFF" value="STAFF">STAFF</option>
                    </select>
                )}
                {(userRole === 'MANAGER') && (
                    <select id="userRole" name="userRole" value={userInput.userRole} className="form-control" onChange={(event) => handleInputChange(event)}>
                        <option className="form-control" key="MANAGER" value="MANAGER">MANAGER</option>
                        <option className="form-control" key="STAFF" value="STAFF">STAFF</option>
                    </select>
                )}
            </div>
            <div className="mb-3">
                <label htmlFor="" className="form-label"></label>
            </div>
            <button type="submit">확인</button>
        </form>
    );
}